import React from "react";

// External
// Internal
import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { ShakespeersProjectSection } from "../../containers/projects";

const ShakespeersProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Shakespeers - Projects"
        description="Full stack MVP for Shakespeers, a US EdTech writing community for kids. React, RedwoodJS, GraphQL, Clerk, Stripe, and serverless deployment."
      />
      <ShakespeersProjectSection />
    </Layout>
  );
};

export default ShakespeersProjectPage;
